import PopupPreviewDocument from './PopupPreviewDocument';

export default PopupPreviewDocument;
